<template>
  <article class="job-offer">
    <div class="job-offer__content">
      <h3>{{ title }}</h3>
      <span class="job-offer__type">{{ type }}</span>
      <p v-html="description" class="job-offer__description"/>
    </div>
    <div class="job-offer__footer">
      <arrow-link :href="link">info</arrow-link>
    </div>
  </article>
</template>

<script>
import ArrowLink from '@/components/ArrowLink'
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    ArrowLink,
    BorderBox
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .job-offer {
    @include vertical-space((bottom: 1), padding);
    @include equal-height-column;

    &__type {
      @include text(big, medium);
      @inlcude vertical-space((bottom: 2), padding);
    }

    &__description {
      @include text;
      @include vertical-space((bottom: 2, top: 1), padding);
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Contact/JobOffer.vue